module.exports = __webpack_public_path__ + "img/binance.2270b8d2.svg";